import type { Variants, Transition } from "framer-motion";

const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];
const EASE_IN:  [number, number, number, number] = [0.4, 0, 1, 1];

const enterT: Transition = { type: "tween", duration: 0.55, ease: EASE_OUT };
const exitT:  Transition = { type: "tween", duration: 0.45, ease: EASE_IN };

export const pageVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  enter:   { opacity: 1, y: 0,  transition: enterT },
  exit:    { opacity: 0, y: -12, transition: exitT },
};